import { useEffect, useState } from 'react'

export function Scanlines() {
    return (
        <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
            {/* Moving Scanline Bar */}
            <div className="absolute inset-x-0 h-[20vh] bg-gradient-to-b from-transparent via-violet-500/10 to-transparent animate-scan-fast" />

            {/* Static Grid Effect */}
            <div className="absolute inset-0 bg-[linear-gradient(rgba(18,16,16,0)_50%,rgba(0,0,0,0.1)_50%),linear-gradient(90deg,rgba(255,0,0,0.03),rgba(0,255,0,0.01),rgba(0,0,255,0.03))] z-[1] bg-[length:100%_4px,4px_100%] opacity-30" />

            {/* Noise / Grain */}
            <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/p6.png')] opacity-[0.03] mix-blend-overlay" />

            {/* Random Glitch Streaks */}
            {Array.from({ length: 5 }).map((_, i) => (
                <div
                    key={i}
                    className="absolute h-[1px] bg-rose-500/20 w-full animate-glitch-streak"
                    style={{
                        top: `${Math.random() * 100}%`,
                        animationDelay: `${Math.random() * 5}s`,
                        animationDuration: `${0.1 + Math.random() * 0.2}s`
                    }}
                />
            ))}
        </div>
    )
}
